class TrAuthorReadMore extends HTMLElement {
	selectors = {
		content: '[data-tr-js-author-read-more-content]',
		button: '[data-tr-js-author-read-more-button]'
	};

	attributes = {};

	stateClasses = {
		isExpanded: 'is-expanded'
	};

	connectedCallback() {
		this.contentElement = this.querySelector(this.selectors.content);
		this.buttonElement = this.querySelector(this.selectors.button);

		this.init();
		this.bindEvents();
	}

	disconnectedCallback() {
		window.removeEventListener('resize', this.onWindowResize);
		this.destroy();
	}

	init() {
		this.isExpanded = this.classList.contains(this.stateClasses.isExpanded);
		this.update();
	}

	bindEvents() {
		if (!this.buttonElement) return;

		this.buttonElement.addEventListener('click', this.onButtonClick);
		window.addEventListener('resize', this.onWindowResize);
	}

	onButtonClick = () => {
		this.isExpanded = !this.isExpanded;
		this.classList.toggle(this.stateClasses.isExpanded, this.isExpanded);
		this.update();
	};

	onWindowResize = () => {
		this.update();
	};

	update() {
		if (!this.contentElement || !this.buttonElement) return;

		const hasOverflow = this.contentElement.scrollHeight > this.contentElement.clientHeight + 1;
		this.buttonElement.hidden = !hasOverflow && !this.isExpanded;
		this.buttonElement.textContent = this.isExpanded
			? this.buttonElement.getAttribute('data-expanded-text')
			: this.buttonElement.getAttribute('data-collapsed-text');
		this.buttonElement.setAttribute('aria-expanded', String(this.isExpanded));
	}

	destroy() {
		if (!this.buttonElement) return;

		this.buttonElement.removeEventListener('click', this.onButtonClick);
	}
}

if (!customElements.get('tr-author-read-more')) {
	customElements.define('tr-author-read-more', TrAuthorReadMore);
}
